import { StringConstantsMixin } from '../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const activities = [
  { value: 'backpacking', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.BACKPACKING },
  { value: 'birding', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.BIRDING },
  { value: 'bike-touring', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.BIKE_TOURING },
  { value: 'camping', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.CAMPING },
  { value: 'cross-country-skiing', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.CROSS_COUNTRY_SKIING },
  { value: 'fishing', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.FISHING },
  { value: 'hiking', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.HIKING },
  { value: 'horseback-riding', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.HORSEBACK_RIDING },
  { value: 'mountain-biking', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.MOUNTAIN_BIKING },
  { value: 'nature-trips', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.NATURE_TRIPS },
  { value: 'off-road-driving', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.OFF_ROAD_DRIVING },
  { value: 'paddle-sports', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.PADDLE_SPORTS },
  { value: 'road-biking', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.ROAD_BIKING },
  { value: 'rock-climbing', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.ROCK_CLIMBING },
  { value: 'scenic-driving', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.SCENIC_DRIVING },
  { value: 'snowshoeing', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.SNOWSHOEING },
  { value: 'skiing', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.SKIING },
  { value: 'trail-running', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.TRAIL_RUNNING },
  { value: 'via-ferrata', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.VIA_FERRATA },
  { value: 'walking', label: StringConstantsMixin.strings.FILTERS.ACTIVITIES.WALKING }
];

const obstacles = [
  { uid: 'great', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.GREAT },
  { uid: 'blowdown', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.BLOWDOWN },
  { uid: 'bridge-out', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.BRIDGE_OUT },
  { uid: 'bugs', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.BUGS },
  { uid: 'closed', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.CLOSED },
  { uid: 'fee', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.FEE },
  { uid: 'flooded', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.FLOODED },
  { uid: 'icy', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.ICY },
  { uid: 'muddy', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.MUDDY },
  { uid: 'no-shade', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.NO_SHADE },
  { uid: 'off-trail', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.OFF_TRAIL },
  { uid: 'over-grown', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.OVER_GROWN },
  { uid: 'private-property', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.PRIVATE_PROPERTY },
  { uid: 'rocky', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.ROCKY },
  { uid: 'scramble', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.SCRAMBLE },
  { uid: 'snow', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.SNOW },
  { uid: 'washed-out', label: StringConstantsMixin.strings.FILTERS.OBSTACLES.WASHED_OUT }
];

export const getActivityByValue = value => {
  return activities.find(activity => {
    return activity.value === value;
  });
};

const defaultHikingActivity = () => {
  return getActivityByValue('hiking');
};

export { activities, obstacles, defaultHikingActivity };
